import { render, staticRenderFns } from "./my.vue?vue&type=template&id=a4a57c9e&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"
import style0 from "./my.vue?vue&type=style&index=0&id=a4a57c9e&prod&lang=scss&scoped=true"
import style1 from "./my.vue?vue&type=style&index=1&id=a4a57c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a57c9e",
  null
  
)

export default component.exports